// extracted by mini-css-extract-plugin
export default {"relative":"G077f3a","absolute":"Gf372e9","fixed":"G762e80","centerCenter":"G0f9ab4"};